import { render, staticRenderFns } from "./bookingDgBlock.vue?vue&type=template&id=0817f1bc&scoped=true"
import script from "./bookingDgBlock.vue?vue&type=script&lang=js"
export * from "./bookingDgBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0817f1bc",
  null
  
)

export default component.exports